export default __webpack_public_path__ + "static/media/UserScreenBlack.b624f521.svg";